<template>
  <div>
    <div>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key">{{ $t("RAM.AWS.tgw.amazonSideAsn") }}</span>
          <span class="expand-value">{{ row.amazonSideAsn }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key">{{ $t("RAM.AWS.tgw.dnsSupport") }}</span>
          <span class="expand-value">{{ row.dnsSupport }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key">{{ $t("RAM.AWS.tgw.vpnEcmpSupport") }}</span>
          <span class="expand-value">{{ row.vpnEcmpSupport }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key">{{
            $t("RAM.AWS.tgw.autoAcceptSharedAttachments")
          }}</span>
          <span class="expand-value">{{
            row.autoAcceptSharedAttachments
          }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key">{{
            $t("RAM.AWS.tgw.defaultRouteTableAssociation")
          }}</span>
          <span class="expand-value">{{
            row.defaultRouteTableAssociation
          }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key">{{
            $t("RAM.AWS.tgw.multicastSupport")
          }}</span>
          <span class="expand-value">{{ row.multicastSupport }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key">{{
            $t("RAM.AWS.tgw.defaultRouteTablePropagation")
          }}</span>
          <span class="expand-value">{{
            row.defaultRouteTablePropagation
          }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
      <Table
        :no-data-text="$t('common.noData')"
        :columns="columns"
        :data="securityData"
        style="width: 100%"
      ></Table>
      </Row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("RAM.AWS.tgw.name"),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline",
                },
                /*   on: {
                                click: () => {
                                    this.$router.push({path: '/resourceConfigurationManagement/aws/subnetResource', query:{subnetIds:params.row.subnetId,type:"subnetId",t:Date.now()}})
                                }
                            } */
              },
              params.row.name
            );
          },
        },
        {
          title: this.$t("RAM.AWS.tgw.transitGatewayAttachmentId"),
          key: "transitGatewayAttachmentId",
        },
        {
          title: this.$t("RAM.AWS.tgw.resourceType"),
          key: "resourceType",
        },
        {
          title: this.$t("RAM.AWS.tgw.resourceId"),
          key: "resourceId",
        },
        {
          title: this.$t("RAM.AWS.tgw.transitGatewaystate"),
          key: "state",
        },
        {
          title: this.$t("RAM.AWS.tgw.transitGatewayRouteTableId"),
          key: "transitGatewayRouteTableId",
        },
        {
          title: this.$t("RAM.AWS.tgw.associationState"),
          key: "associationState",
        },
        {
          title: this.$t("RAM.AWS.tgw.creationTime"),
          key: "creationTime",
        },
      ],
      securityData: this.row.attachmentDTOList,
    };
  },
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/tgw/TableExpand.vue